import styleInject from '../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".vai-list {\n  width: 100%;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}";
styleInject(css_248z,{"insertAt":"top"});

export { css_248z as default };
